import React, { useState } from "react";
import { useSelector } from "react-redux";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { MemberList } from "src/app/components/MemberList/MemberList";
import SelectMemberOrTeam from "src/app/components/SelectMemberOrTeam/SelectMemberOrTeam";
import { ProjectRoles } from "src/app/SettingsModal/tabs/Members/utils";
import { SetObjectState } from "src/hooks/useObjectState";
import { RootState } from "src/redux/reducers";
import { CCMonitorState } from "src/types";

type MemberOption = {
  label: string;
  members: {
    avatarUrl: string;
    email: string;
    name: string;
    uuid: string;
  }[];
  name: string;
  type: string;
  value: string;
};

interface Props {
  monitorData: CCMonitorState;
  setMonitorData: SetObjectState<CCMonitorState>;
}

export const CCMNotifications = (props: Props) => {
  const { monitorData, setMonitorData } = props;

  const [selectedOptions, setSelectedOptions] = useState<MemberOption[]>([]);
  const { projectBasicData } = useSelector(
    (state: RootState) => state.projectReducer,
  );

  const deleteMember = (memberId: string) => {
    const memberIds = monitorData.notificationWsMembers.filter(
      (id) => id !== memberId,
    );

    setMonitorData({
      notificationWsMembers: memberIds,
    });
  };

  const addMembersToMonitor = async () => {
    const memberIds: string[] = [...monitorData.notificationWsMembers];

    selectedOptions.forEach((item) => {
      if (item.type === "member") {
        memberIds.push(item.value);
      }

      // if (item.type === "team") {
      //   memberIds.push(...item.members.map((member) => member.uuid));
      // }
    });

    setMonitorData({ notificationWsMembers: memberIds });
    setSelectedOptions([]);
  };

  const getFilteredMembers = () => {
    const allowedRoles = [
      ProjectRoles.Admin,
      ProjectRoles.Moderator,
    ] as string[];

    return (
      projectBasicData?.members?.filter((member) => {
        const memberRole = member.memberRole;

        return member.status !== "removed" && allowedRoles.includes(memberRole);
      }) || []
    );
  };

  const filteredMembers = getFilteredMembers();

  const membersWithNotification = filteredMembers?.filter((item) =>
    monitorData?.notificationWsMembers?.includes(item.id),
  );

  return (
    <div>
      <p className="creator-content-monitoring__description">
        <IDHFormattedMessage
          id="ws_creator_content_monitor_notifications_description"
          defaultMessage="Please select members to receive email notification about the detection of a new publication."
        />
      </p>

      <SelectMemberOrTeam
        selectedOptions={selectedOptions}
        setSelectedOptions={setSelectedOptions}
        members={filteredMembers}
        teams={[]}
        membersWithNotification={monitorData.notificationWsMembers}
        addButtonClick={addMembersToMonitor}
      />

      <MemberList
        header={
          <IDHFormattedMessage
            id="ws_people_with_access"
            defaultMessage="People with access"
          />
        }
        members={membersWithNotification}
        actions={{
          deleteMember,
        }}
      />
    </div>
  );
};
